export const SET_HS_POPUP_DETAILS = 'SET_HS_POPUP_DETAILS';

export const setHSPopup = value => {
  // {show: false, component: '', data: {}}
  return dispatch => {
    dispatch({ type: SET_HS_POPUP_DETAILS, payload: value });
  };
};
